module.exports = __webpack_public_path__ + "1404f10a4acab7e02ca08fb181c967de.svg";